"use strict";
import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AuthTokenContext } from "./AuthTokenContext";
export const AuthTokenProvider = ({ authToken, children }) => {
  const value = useMemo(() => ({ authToken }), [authToken]);
  return /* @__PURE__ */ jsx(AuthTokenContext.Provider, { value, children });
};
